// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightSquareOutlinedSvg from "@fishx/icons-svg/es/asn/RightSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var RightSquareOutlined = function RightSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareOutlinedSvg
  }));
};

RightSquareOutlined.displayName = 'RightSquareOutlined';
export default React.forwardRef(RightSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RightSquareOutlined.js
// module id = 4019
// module chunks = 0